import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'uikit/modals';

import useModals from '../hooks/useModals';

const QueryModal = ({ modal = {} }) => {
  const [hasFormLoaded, setHasFormLoaded] = useState(false);

  let hasFormError = false;

  let formState = {};

  const { removeModal, setModel } = useModals();
  const { id, model } = modal;

  const onActionClicked = ({ action, callback }) => {
    if (callback) return callback({ payload: model, type: action });

    return removeModal({ id, type: action });
  };

  const onFormUpdate = ({ update, hasError, formState: updatedFormState }) => {
    hasFormError = hasError;
    formState = updatedFormState;
    setModel(id, { ...model, ...update });
  };

  const onFormLoad = ({ hasError, formState: updatedFormState }) => {
    hasFormError = hasError;
    formState = updatedFormState;

    setHasFormLoaded(true);
  };

  const onCloseButtonClicked = () => {
    const callback = modal.actions?.find(({ action }) => action === 'CLOSE')?.callback;

    onActionClicked({ action: 'CLOSE', callback });
  };

  return (
    <Modal
      ariaLabel={modal.ariaLabel}
      closeButtonAriaLabel={modal.closeButtonAriaLabel}
      formState={formState}
      hasFormError={hasFormError}
      hasFormLoaded={hasFormLoaded}
      isFocusLockDisabled={modal.isFocusLockDisabled}
      modal={modal}
      modalData={model}
      onActionClicked={onActionClicked}
      onCloseButtonClicked={onCloseButtonClicked}
      onFormLoad={onFormLoad}
      onFormUpdate={onFormUpdate}
    />
  );
};

QueryModal.propTypes = {
  modal: PropTypes.shape({
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        action: PropTypes.string,
        callback: PropTypes.func,
      }),
    ),
    ariaLabel: PropTypes.string,
    closeButtonAriaLabel: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isFocusLockDisabled: PropTypes.bool,
  }),
};

export default QueryModal;
